/** Shared Fachkompetenz pill surface. Filled surfaces bind the ink for text AND nested icons. */
export function requirementPillClasses({ isMust, selected = false, editing = false }: {
  isMust: boolean;
  selected?: boolean;
  editing?: boolean;
}) {
  const surface = selected
    ? "bg-ink text-ink font-semibold ring-0"
    : isMust
      ? "bg-accent text-ink font-semibold ring-0"
      : `text-ink ${editing ? "ring-2 ring-accent-decoration" : "ring-1 ring-accent-decoration/40"}`;
  return `inline-flex max-w-full items-center gap-1.5 rounded-full px-2.5 py-1 text-smycles-meta transition ${surface} ${editing ? "smycles-selected" : ""}`;
}
